import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchPrizes } from '../actions/prize.actions';
import { clearPrizesError } from '../reducer/prize.reducer';

export const usePrizeActions = () => {
    const dispatch = useDispatch();

    const getPrizes = useCallback(() => {
        dispatch(fetchPrizes() as any);
    }, [dispatch]);

    const clearError = useCallback(() => {
        dispatch(clearPrizesError());
    }, [dispatch]);

    return {
        getPrizes,
        clearError
    };
};
